import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Timer from 'interview/components/sequenced-interview/timer'
import Question from 'components/question'
import { Flex } from 'components/styled/containers/flex'
import { Button } from 'components/styled/button'
import { LoadingIndicator } from 'components/styled/loading-indicator'
import { timedInterviewAllowNotAnswerableQuestions } from 'flags'
import { Body } from 'components/styled/typography'
import getTextQuestionTime from '../get-text-question-time'

const propTypes = {
  buttonText: PropTypes.string,
  hasError: PropTypes.bool,
  timerCount: PropTypes.number.isRequired,
  currentQuestion: PropTypes.shape({
    videoUrl: PropTypes.string,
    textQuestion: PropTypes.string,
    answerable: PropTypes.bool,
  }).isRequired,
  language: PropTypes.string.isRequired,
  updateState: PropTypes.func.isRequired,
  reconnecting: PropTypes.bool,
  candidateState: PropTypes.string.isRequired,
  updateTextQuestion: PropTypes.func.isRequired,
  languageKeys: PropTypes.shape({
    nonAnswerableText: PropTypes.string,
    nonAnswerableVideo: PropTypes.string,
  }),
  buttonEventData: PropTypes.shape({
    candidateId: PropTypes.string,
    companyId: PropTypes.string,
    companyName: PropTypes.string,
  }),
}

const defaultProps = {
  hasError: false,
  reconnecting: false,
  buttonText: '',
  languageKeys: undefined,
  buttonEventData: {},
}

const QuestionContainer = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
`
export function QuestionView({
  buttonText,
  hasError,
  timerCount,
  currentQuestion,
  reconnecting,
  updateState,
  candidateState,
  updateTextQuestion,
  languageKeys,
  buttonEventData,
  language,
}) {
  if (reconnecting || hasError) {
    return null
  }
  if (!currentQuestion.videoUrl && !currentQuestion.textQuestion && !hasError) {
    return <LoadingIndicator />
  }
  const textQuestionLength =
    currentQuestion.textQuestion && currentQuestion.textQuestion.length
  const textQuestionTime = getTextQuestionTime(textQuestionLength)
  const onTextQuestion =
    !currentQuestion.videoUrl &&
    currentQuestion.textQuestion &&
    candidateState.includes('textquestion')
  const questionContainerRef = React.useRef(null)

  useEffect(() => {
    if (questionContainerRef && questionContainerRef.current) {
      questionContainerRef.current.scrollIntoView({ behavior: 'smooth' })
    }
  }, [])

  return (
    <>
      <QuestionContainer ref={questionContainerRef}>
        {timedInterviewAllowNotAnswerableQuestions() &&
          !currentQuestion.answerable &&
          currentQuestion.textQuestion && (
            <Body mb="s8" className="non-answerable-text">
              {languageKeys.nonAnswerableText}
            </Body>
          )}
        {timedInterviewAllowNotAnswerableQuestions() &&
          !currentQuestion.answerable &&
          !currentQuestion.textQuestion && (
            <Body mb="s8" className="non-answerable-video">
              {languageKeys.nonAnswerableVideo}
            </Body>
          )}
        <Question
          playable
          timedInterview
          title=" "
          question={currentQuestion}
          updateState={updateState}
        />
        {onTextQuestion && (
          <Timer
            timerCount={timerCount}
            totalTime={textQuestionTime}
            textQuestion
          />
        )}
      </QuestionContainer>
      {onTextQuestion && (
        <Flex mt="s20" alignItems="center" flexDirection="column">
          <Button
            loading={
              timerCount === textQuestionTime &&
              candidateState.includes('textquestion')
            }
            iconRight={language === 'ar' ? 'west' : 'east'}
            text={buttonText}
            onClick={() => updateTextQuestion(textQuestionTime)}
            event={{
              locationId: 'timedInterviewPage',
              id: 'skipTextQuestionButton',
              properties: buttonEventData,
            }}
          />
        </Flex>
      )}
    </>
  )
}

QuestionView.propTypes = propTypes
QuestionView.defaultProps = defaultProps

export default QuestionView
